import NewBudgetReimbursementRootPage from '@/common/pages/(private)/(dashboard)/budgets/reimbursement/new';

export default function Page() {
  return <NewBudgetReimbursementRootPage />;
}
